import * as React from "react";
import { forwardRef } from "react";
const SvgClosed = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m10 7 3.92 4.764c.051.063.08.148.08.236a.372.372 0 0 1-.08.236L10 17" }));
const ForwardRef = forwardRef(SvgClosed);
export { ForwardRef as ReactComponent };
